import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { ObjectType } from '../Enums/ObjectType.enum';

import { User } from './User.entity';

export class CommentEvent<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: creationDate */
  creationDate?: string;
  /** Alias: objectType */
  objectType?: ObjectType;
  /** Alias: objectId */
  objectId?: string;
  /** Alias: userCode */
  userId?: number;
  /** Alias: user */
  user?: User<T>;
  /** Alias: text */
  text?: string;
  /** Alias: childs */
  childs?: CommentEvent<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<CommentEvent> = {
  id: {
    alias: 'id',
  },
  creationDate: {
    alias: 'creationDate',
  },
  objectType: {
    alias: 'objectType',
  },
  objectId: {
    alias: 'objectId',
  },
  userId: {
    alias: 'userCode',
  },
  user: {
    alias: 'user',
    entity: Entities.user,
  },
  text: {
    alias: 'text',
  },
  childs: {
    alias: 'childs',
    entity: Entities.commentEvent,
  },
  __typename: {
    alias: '__typename',
  },
};

export const commentEventEntityDefinition: EntitiyDefinition<CommentEvent> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'CommentEvent',
    withPaginationWrapper: false,
    mutations: {
      upsert: {
        mutationName: 'addComment',
        args: [
          { name: 'codeOrId', type: 'String!' },
          { name: 'objectType', type: 'ObjectType!' },
          { name: 'comment', type: 'String!' },
          { name: 'replyTo', type: 'ID' },
        ],
      },
    },
  },
  fieldDefinitions: fields,
};
